import { APIClient } from '@dvag/dfs-api-client';
import { getContext, getToken } from '@dvag/dfs-orchestrator-client';

export const getApiClient = (baseURL: string, attachParentUserId = true) => {
  const apiClient = new APIClient({ baseURL })
    .withResErrorHandling()
    .withReqTokenHeader(getToken);
  const parentUserId = getContext()?.user?.parentUserId;

  if (!parentUserId || !attachParentUserId) {
    return apiClient;
  }

  return apiClient.withReqParentUserIdHeader(() => getContext()?.user?.parentUserId ?? '');
};
